export default "__VITE_ASSET__OrclPbOO__"